import { render, staticRenderFns } from "./DigitalSolutionImage.vue?vue&type=template&id=054d49bc&"
import script from "./DigitalSolutionImage.vue?vue&type=script&lang=js&"
export * from "./DigitalSolutionImage.vue?vue&type=script&lang=js&"
import style0 from "./DigitalSolutionImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports